import { Box, Typography } from '@mui/material'
import CloudOffIcon from '@mui/icons-material/CloudOff'
import { useTranslation } from 'react-i18next'
import { useOnlineStatus } from '../hooks/useOnlineStatus'

/** Slim app-wide strip shown while the browser is offline. Mounted in Layout. */
export function OfflineBanner() {
  const { t } = useTranslation()
  const online = useOnlineStatus()
  if (online) return null
  return (
    <Box
      role="status"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        px: 2,
        py: 0.75,
        mb: 1.5,
        borderRadius: 2,
        bgcolor: 'warning.light',
        color: 'warning.contrastText',
      }}
    >
      <CloudOffIcon sx={{ fontSize: 18 }} />
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        {t('offline.banner')}
      </Typography>
    </Box>
  )
}
